import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = [ "menu", "toggle", "desktop", "mobile" ]

    connect() {
        this.updateVisibility()
        this.setCurrentPageAsButton()
        window.addEventListener("resize", this.updateVisibility.bind(this))
    }

    disconnect() {
        window.removeEventListener("resize", this.updateVisibility.bind(this))
    }

    toggle() {
        this.menuTarget.classList.toggle("visually-hidden")
    }

    updateVisibility() {
        if (window.innerWidth < 750) {
            this.desktopTarget.classList.add("visually-hidden")
            this.mobileTarget.classList.remove("visually-hidden")
            this.toggleTargets[0].classList.remove("visually-hidden")
            this.menuTargets[0].classList.add("visually-hidden")
        } else {
            this.mobileTarget.classList.add("visually-hidden")
            this.desktopTarget.classList.remove("visually-hidden")
            this.toggleTargets[1].classList.add("visually-hidden")
            this.menuTargets[1].classList.remove("visually-hidden")
        }
    }

    setCurrentPageAsButton() {
        const currentPage = document.title.split("|").shift() || window.location.pathname.split("/").pop() || "Home"
        this.toggleTarget.textContent = currentPage
    }
}